import {OrbitControls} from '../camera_controls/OrbitControls'
import * as THREE from "three"
import {DefaultDeviceHandler} from "./default_device_handler";

export class ThreeThirdPersonHandler extends DefaultDeviceHandler {
	cameraOffset = {x: 0, y: 0, z: 0};

	camera = null;

	raycaster = null

	scene = null

	maxZoom = 44;

	VECTOR_ZERO = new THREE.Vector2(0, 0)

	isFirstPerson = false

	// cameraTarget

	arrow

	constructor(scene) {
		super("3D3rd");
		this.setupListeners();

		this.scene = scene
		this.raycaster = new THREE.Raycaster();
		// this.raycaster.layers.set(4); //Terrain layer
	}

	reset() {
		super.reset()
		this.isFirstPerson = false

		this.deviceControls.removeEventListener("change", () => {this.onDeviceChange()})
		window.removeEventListener('keyup', (e) => this.onKeyUp(e))
		window.removeEventListener('wheel', (e) => this.onWheel(e));
	}

	setupListeners() {
		//
	}

	setMaxZoom(zoomLevel) {
		this.maxZoom = zoomLevel
	}

	setTarget(target, onChange) {
		// console.log("Setting target to: ", target);
		super.setTarget(target);
		onChange(target, this.rotation)

		this.camera.lookAt(target)
		this.deviceControls.update();
	}

	animate(delta, onChange) {
		this.deviceControls.update()
	}

	getOffset() {
		return this.cameraOffset;
	}

	setPlayer(ent) {
		super.setPlayer(ent);
		const box = new THREE.Box3().setFromObject(ent.obj);

		// this.cameraOffset.y = box.max.y / 4;
		this.cameraOffset.y = box.max.y;
		// this.cameraOffset.y = box.max.y * (ent.scale.y < 1 ? ent.scale.y : 1);

		this.deviceControls.target = ent.obj.position.clone().add(this.getOffset())
		console.log("3D3RD - Setting player to: ", ent.position, ent.obj.position.clone().add(this.getOffset()));

		this.camera.position.set(ent.obj.position.x, ent.obj.position.y+3,ent.obj.position.z)
		this.camera.lookAt(ent.obj.position)
		this.deviceControls.update();
	}

	bindControls(camera, domElement, scene) {
		if(this.deviceControls) {
			this.reset()
		}

		this.camera = camera;
		this.scene = scene
		this.deviceControls = new OrbitControls(camera, domElement);
		this.deviceControls.enablePan = false
		this.deviceControls.maxDistance = 4
		this.deviceControls.minDistance = 4
		this.deviceControls.maxPolarAngle = Math.PI / 2
		this.deviceControls.update();
		this.deviceControls.maxPolarAngle = 160 * (Math.PI / 180)

		this.raycaster.far = this.deviceControls.maxDistance

		this.deviceControls.addEventListener("change", () => {this.onDeviceChange()})
		window.addEventListener('keyup', (e) => this.onKeyUp(e))
		window.addEventListener('wheel', (e) => this.onWheel(e));

		return this.deviceControls;
	}

	onDeviceChange() {
		this.checkCameraCollision(this.camera, this.scene, this.collisionHandler.getActiveColliders())
	}

	onKeyUp(e) {
		if (e.key === "p") {
			this.toggleFirstPerson()
		}
	}

	onWheel(e) {
		if (this.isFirstPerson)
			return;

		if (e.target.nodeName !== "CANVAS" && !e.detail.ui_click)
			return;

		if (e.detail.ui_click) //If UI Click then data is held within detail
			e.deltaY = e.detail.deltaY

		let nd = this.deviceControls.minDistance + (e.deltaY / 100)

		if (nd <= 0)
			return; //Do nothing

		if (this.maxZoom > 0 && nd > this.maxZoom)
			nd = this.maxZoom; //Cap

		this.deviceControls.minDistance = nd
		this.deviceControls.maxDistance = nd

		this.raycaster.far = this.deviceControls.maxDistance
		// this.raycaster.far = Math.round((nd / 100) * 80)

	}

	toggleFirstPerson() {
		this.isFirstPerson = !this.isFirstPerson
		const nd = this.isFirstPerson ? 0.01 : 1
		this.deviceControls.minDistance = nd
		this.deviceControls.maxDistance = nd

		if (this.player) {
			this.player.obj.visible = !this.isFirstPerson
		}
	}

	//@override
	checkCameraCollision(camera, scene, colliders = []) {
		super.checkCameraCollision(camera, scene)

		if (!this.player || this.isFirstPerson)
			return

		this.raycaster.setFromCamera(this.VECTOR_ZERO, camera)

		// const intersects = this.raycaster.intersectObjects(filtered, true)
		const intersects = this.raycaster.intersectObjects(colliders, true)
		// const cameraDistance = this.deviceControls.target.distanceTo(camera.position)
		if (intersects.length > 0) {
			const is = intersects[intersects.length - 1]
			const d2 = is.point.distanceTo(camera.position)
			// console.log("CameraCollision",this.deviceControls, is, d2)
			this.camera.position.lerpVectors(is.point, this.deviceControls.target, 0.2)
			// this.camera.position.set(is.point.x, is.point.y, is.point.z)
		}
	}

	getPosition() {
		if (this.player === null)
			return null;

		return this.player.obj.position.clone()
	}

	getRotation() {
		return this.player.obj.rotation.clone()
	}

	getAngle() {
		if (!this.deviceControls)
			return 0;

		// return 0
		return 0
	}
}
